// extracted by mini-css-extract-plugin
export default {"list":"QuestionnaireItem_list__DrlDs","card":"QuestionnaireItem_card__fxhLH","cardImportant":"QuestionnaireItem_cardImportant__aLNmb"};